export const secureOTPRoute = {
  path: '/secure-otp',
  name: 'secure-otp',
  component: () => import(/* webpackChunkName: "SecureOTPForm" */ '../../components/SecureUpload/SecureOTPForm.vue'),
  meta: { publicRoute: true },
}
